import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authReq = req;
    const token = this.auth.getToken();
    if (token) {
      authReq = req.clone({ headers: req.headers.set('Authorization', 'Bearer ' + token) });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        const backendBase = environment.apiUrl;
        // If an API request to backend fails with 404 or network failure (often due to missing .htaccess in cPanel subfolder),
        // gracefully retry via direct /index.php/ path routing
        if (
          (error.status === 404 || error.status === 0) &&
          authReq.url.startsWith(backendBase) &&
          !authReq.url.includes('/index.php/')
        ) {
          const fallbackUrl = authReq.url.replace(backendBase, backendBase + '/index.php');
          const fallbackReq = authReq.clone({ url: fallbackUrl });
          return next.handle(fallbackReq);
        }
        return throwError(() => error);
      })
    );
  }
}

